import { EmployeeSummaryDto } from './employee-summary-dto.model';


export class ExtraPayApplicationDto implements IExtraPayApplicationDto {
    id!: number;
    employee!: EmployeeSummaryDto;
    approver!: EmployeeSummaryDto;
    payDate!: Date;
    payAmount!: number;
    payMonth!: string | undefined;
    payRemark!: string | undefined;
    allowanceType!: string | undefined;
    payReferenceId!: number | undefined;

    constructor(data?: IExtraPayApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.approver = _data["approver"] ? EmployeeSummaryDto.fromJS(_data["approver"]) : <any>undefined;
            this.payDate = _data["payDate"] ? new Date(_data["payDate"].toString()) : <any>undefined;
            this.payAmount = _data["payAmount"];
            this.payMonth = _data["payMonth"];
            this.payRemark = _data["payRemark"];
            this.allowanceType = _data["allowanceType"];
            this.payReferenceId = _data["payReferenceId"];
        }
    }

    static fromJS(data: any): ExtraPayApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraPayApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["approver"] = this.approver ? this.approver.toJSON() : <any>undefined;
        data["payDate"] = this.payDate ? this.payDate.toISOString() : <any>undefined;
        data["payAmount"] = this.payAmount;
        data["payMonth"] = this.payMonth;
        data["payRemark"] = this.payRemark;
        data["allowanceType"] = this.allowanceType;
        data["payReferenceId"] = this.payReferenceId;
        return data; 
    }
}

export interface IExtraPayApplicationDto {
    id: number;
    employee: EmployeeSummaryDto;
    approver: EmployeeSummaryDto;
    payDate: Date;
    payAmount: number;
    payMonth: string | undefined;
    payRemark: string | undefined;
    allowanceType: string | undefined;
    payReferenceId: number | undefined;
}

